import { Backdrop, Button, Fade, Grid, Modal, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { addCatalogTree, deleteCatalogTree, getBreadcrumbs, getDataStructure, setCatalogTree } from "src/services/api";
import { DataStructureType } from "src/types/datastructure";
import { getInputValueByType } from "src/providers/inputProvider";
import useNotifications from "src/pages/Notifications/useNotifications";

type CategoryDeleteModalProps = {
    open: boolean;
    handleClose: () => void;
    categoryParentId: string;
    backToParentCateg: () => void;
};

const modalStyle = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 3,
    overflow: "scroll",
    maxHeight: "50vh",
};

const CategoryDeleteModal = (props: CategoryDeleteModalProps) => {
    let { open, handleClose, categoryParentId, backToParentCateg } = props;
    const { addNotification } = useNotifications();

    const [errorFromApi, setErrorFromApi] = useState<string>();
    const [categoryInfos, setCategoryInfos] = useState<any>();

    useEffect(() => {
        if (categoryParentId) {
            getBreadcrumbs(categoryParentId)
                .then((data: any) => {
                    setCategoryInfos(data.data[data.data.length - 1]);
                })
                .catch((error) => {
                    setCategoryInfos(null);
                });
        }
    }, []);

    const deleteCategory = () => {
        deleteCatalogTree(categoryParentId)
            .then((data: any) => {
                backToParentCateg();
                addNotification("success", "Catégorie supprimée", "La catégorie a bien été supprimée !");
            })
            .catch((e: any) => {
                setErrorFromApi(e.response.data.error);
                addNotification("danger", "Une erreur est survenue", "La catégorie n'a pas pu être supprimée...");
            });
    };

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <Box sx={modalStyle}>
                    {categoryInfos && !errorFromApi && (
                        <>
                            <Typography id="transition-modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
                                Suppression de la catégorie <br /> {categoryInfos.category_name}
                            </Typography>
                            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                                Confirmez-vous la demande de suppression de la catégorie ?
                            </Typography>
                            <Box sx={{ display: "flex", width: "100%", mt: 3, alignItems: "center", justifyContent: "center" }}>
                                <Button onClick={deleteCategory}>Supprimer la catégorie</Button>
                            </Box>
                        </>
                    )}
                    {categoryInfos === undefined && <p>TODO loader</p>}
                    {categoryInfos === null && <p>Une erreur est survenue, veuillez rééssayer plus tard...</p>}
                    {errorFromApi && (
                        <Typography variant="h6" component="h3" sx={{ color: "red" }}>
                            {errorFromApi}
                        </Typography>
                    )}
                </Box>
            </Fade>
        </Modal>
    );
};

export default CategoryDeleteModal;
